import React from 'react';
import { Button, Tooltip } from 'antd';
import { PlayCircleOutlined, PauseCircleOutlined, StopOutlined } from '@ant-design/icons';
import { useTimeTracking } from '../../hooks/useTimeTracking';

const TimeTracker = ({ planId, size = 'default', showTime = true, showStop = false }) => {
  const {
    isTracking,
    formattedTime,
    toggleTracking,
    stopTracking,
    isCurrentPlan
  } = useTimeTracking(planId);

  const getButtonProps = () => {
    if (isTracking && isCurrentPlan) {
      return {
        icon: <PauseCircleOutlined />,
        type: 'primary',
        danger: false,
        tooltip: 'Pause time tracking'
      };
    } else if (!isTracking && isCurrentPlan) {
      return {
        icon: <PlayCircleOutlined />,
        type: 'default',
        danger: false,
        tooltip: 'Resume time tracking'
      };
    } else {
      return {
        icon: <PlayCircleOutlined />,
        type: 'primary',
        danger: false,
        tooltip: 'Start time tracking'
      };
    }
  };

  const buttonProps = getButtonProps();

  return (
    <div className="flex items-center gap-2">
      <Tooltip title={buttonProps.tooltip}>
        <Button
          icon={buttonProps.icon}
          type={buttonProps.type}
          danger={buttonProps.danger}
          size={size}
          onClick={toggleTracking}
          className={isTracking && isCurrentPlan ? 'animate-pulse' : ''}
        />
      </Tooltip>
      
      {showStop && isCurrentPlan && (
        <Tooltip title="Stop and save time tracking">
          <Button
            icon={<StopOutlined />}
            size={size}
            onClick={stopTracking}
          />
        </Tooltip>
      )}
      
      {showTime && isCurrentPlan && (
        <div className="text-sm font-mono">
          <span className={isTracking ? 'text-green-600 font-semibold' : 'text-gray-500'}>
            {formattedTime}
          </span>
        </div>
      )}
    </div>
  );
};

export default TimeTracker;
